/* eslint-disable import/prefer-default-export */
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useCartStore } from '@features/cart/mobx/context/CartStoreProvider';
import browserStorage from '@utils/browserStorage';
import { getRegion } from '@utils/misc';
export const useCartSync = () => {
  const cartStore = useCartStore();
  const region = getRegion();
  const {
    locale
  } = useRouter();
  useEffect(() => {
    void cartStore.ensureCartLanguageMatchesLocale();
  }, [locale, cartStore]);
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        const storageCartId = browserStorage ? browserStorage.getItem(`cartId_${region}`) : null;
        if (storageCartId === cartStore.cartId) {
          if (cartStore.cartId !== '' && storageCartId !== '') {
            void cartStore.refreshCart();
          }
        } else if (cartStore.getCartFromLocalStorage()) {
          void cartStore.fetchAndPopulateCartStore();
        }
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [cartStore]);
};